var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.onShow)?_c('div',{staticClass:"noidentify-pop"},[_c('div',{staticClass:"contentPop"},[_c('h3',{staticClass:"tips"},[_vm._v("提示")]),_c('p',{staticClass:"font"},[_vm._v("系统未识别到，请上传正确的图片")]),_c('div',{staticClass:"know",on:{"click":_vm.onClose}},[_vm._v("我知道了")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }